<template>
  <dimmed>
    <content-box class="confirm-page-add--wrap" :width="'530px'">
      <p class="info-icon">
        <span class="icon icon--alert"></span>
      </p>
      <p class="title" v-html="$t('page.checkDupUrl.title')"></p>
      <p class="desc">
        <span v-html="$t(`page.checkDupUrl.desc.${descType}`, { count: pageList.length })"></span><br>
        <span v-html="$t('page.checkDupUrl.desc2')"></span>
      </p>
      <div class="table--wrap">
        <table>
          <thead>
            <tr>
              <th width="94">{{ $t('common.countryCode') }}</th>
              <th width="82">{{ $t('common.group') }}</th>
              <th width="175">{{ $t('common.table.header.page') }}</th>
              <th width="109">{{ $t('common.table.header.analysisStatusNoWrap') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in pageList" :key="index">
              <td>
                <div class="ellipsis" style="width:94px;">
                  {{ item.siteCode }}
                </div>
              </td>
              <td>
                <div class="ellipsis" style="width:82px;">
                  {{ item.category }}
                </div>
              </td>
              <td>
                <div class="ellipsis" style="width:175px;">
                  {{ item.pageName }}
                </div>
              </td>
              <td :class="item.state">
                <div class="ellipsis" style="width:109px;">
                  {{ $t(`page.state.${item.state}`) }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="action">
        <ui-button class="btn-no"
          primary3
          @click="onCloseLayer(false)">{{ $t('common.cancel') }}</ui-button>
        <ui-button
          primary2
          :disabled="!canSubmit"
          @click="onCloseLayer(true)">{{ $t('common.register') }}</ui-button>
      </p>
    </content-box>
  </dimmed>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import Dimmed from '@/components/ui/Dimmed'

export default {
  components: {
    ContentBox,
    UiButton,
    Dimmed
  },
  props: [
    'pageList',
    'canSubmit'
  ],
  computed: {
    descType () {
      switch (this.$i18n.locale) {
        case 'ko':
        case 'en':
          if (this.pageList.length < 2) {
            return 'singular'
          }
          break
        case 'ja':
          if (this.pageList.length < 10) {
            return 'singular'
          }
          break
      }
      return 'plural'
    }
  },
  data () {
    return {

    }
  },
  methods: {
    onCloseLayer (value) {
      if (value) {
        this.$emit('onSubmit')
      } else {
        this.$emit('onCancel')
      }
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.confirm-page-add--wrap {
  @include positionXYcenter;
  padding: 30px 30px 25px 30px;
  box-sizing: border-box;
  text-align: center;

  .info-icon {
    padding-top: 20px;
    margin-bottom: 15px;
  }

  .title {
    font-size: 20px;
    font-weight: bold;
    color: #444;
    margin-bottom: 12px;
  }
  .desc {
    font-size: 14px;
    line-height: 1.43;
    color: #2f2f2f;
  }

  .table--wrap {
    margin-top: 20px;
    position: relative;

    table {
      text-align: center;
      table-layout: fixed;
      border-collapse: collapse;

      thead {
        tr {
          display: block;
          background-color: #555;
          th {
            position: relative;
            height: 40px;
            box-sizing: border-box;
            color: #fff;
            line-height: 1.23;

            &:first-of-type:before,
            &:last-of-type:before {
              content: "";
              display: inline-block;
              width: 15px;
              height: 40px;
              position: absolute;
              top: 0;
              left: -5px;
              background-color: #555;
              border-radius: 5px;
            }

            &:last-of-type:before {
              left: auto;
              right: -5px;
            }

            &.funnel-name {
              padding-left: 10px;
              text-align: left;
            }
            &.funnel-state {
              text-align: left;
              padding-left: 38px;
            }
            &.funnel-date {
              padding-left: 22px;
              text-align: left;
            }
          }
        }
      }
    }

    tbody {
      display: block;
      width: 100%;
      height: 181px;
      overflow-y: scroll;
      tr {
        height: 60px;
        border-bottom: 1px solid #ebebeb;
      }

      td {
        .ellipsis {
          padding-left: 8px;
          padding-right: 8px;
          box-sizing: border-box;
          line-height: 2;
        }

        &.start {
          color: $stateRunColor;
        }
        &.ing {
          color: $stateAnalyzingColor;
        }
        &.stop {
          color: $stateStopColor;
        }
        &.deleted {
          color: $errorColor;
        }
        &.error {
          color: $stateUnInstalledColor;
        }
        &.pending {
          color: $pendingColor;
        }
        &.run {
          color: $stateRunColor;
        }
        &.analyzing {
          color: $stateAnalyzingColor;
        }
      }
    }
  }

  .action {
    padding-top: 25px;
    .btn-no {
      margin-right: 5px;
    }
  }
}
</style>
